import { render, staticRenderFns } from "./TenantModal.vue?vue&type=template&id=ddd85c96&scoped=true"
import script from "./TenantModal.vue?vue&type=script&lang=js"
export * from "./TenantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd85c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddd85c96')) {
      api.createRecord('ddd85c96', component.options)
    } else {
      api.reload('ddd85c96', component.options)
    }
    module.hot.accept("./TenantModal.vue?vue&type=template&id=ddd85c96&scoped=true", function () {
      api.rerender('ddd85c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/TenantModal.vue"
export default component.exports